module.exports = __webpack_public_path__ + "img/gzh_ewm_2.6f88cffc.png";